// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2aMK7","rightAdornment":"Header_rightAdornment__LnEpE"};